export default __webpack_public_path__ + "static/media/keller-new-devices.5188d6b0.png";